import { Action } from '@ngrx/store';
import * as ReqQuoteCalculationActions from './../actions/request-quote-calculation.actions';

export type Actions = ReqQuoteCalculationActions.Actions;

// const initialState: BeforeStart = {
//     financialAdvise: '',
//     pensionGuidance: '',
//     retirementOptions: ''
// };

// const newState = (state, newData) => {
//     return Object.assign({}, state, newData);
// };

export function ReqQuoteCalculationReducer(state = [], action: ReqQuoteCalculationActions.Actions) {
    switch (action.type) {
        case ReqQuoteCalculationActions.ADD_REQ_QUOTE_CALCULATION:
            return [...state, action.payload];
        // return newState(state, { quoteReferenceNumber: action.payload });

        // Add this case:
        case ReqQuoteCalculationActions.REMOVE_REQ_QUOTE_CALCULATION:
            state = []; // [...state].splice(action.payload, 1);
            return state;

        default:
            return state;
    }
}
